import React, { useState } from 'react'
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { ClinicDashBoard2 } from '../dashboards/ClinicDashBoard2';
import { useAddClinicMutation } from '../../lib/api/clinicAPI';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const AddClinic = () => {
    const [phone, setPhone] = useState('');
    const [addClinic] = useAddClinicMutation();
    const navigate = useNavigate();
    const accessToken = useSelector((state) => state.auth.accessToken);
    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        const name = data.get('name');
        const email = data.get('email');
        const specialities = data.get('specialities');
        const city = data.get('city');
        const state = data.get('state');
        const regd = data.get('regd');
        const pin = data.get('pin');
        const clinic = {
            clinicName: name,
            clinicEmail: email,
            clinicGSTIN: regd,
            clinicContactNumber: phone,
            clinicAddress: {
                cityName: city,
                state: state,
                country: 'India',
                pincode: Number(pin),
            },
        };
        console.log(clinic);
        console.log(accessToken);
        const res = addClinic(accessToken, clinic);
        if (res.data) {
            alert('Clinic added successfully');
        } else {
            alert('Failed to add clinic');
        }
        navigate('/admin')
    }
    return (
        <div className='flex h-full justify-between w-full'>
            <div className='w-[70%] flex flex-col my-10 items-center'>
                <form className='bg-white rounded-lg flex flex-col items-center shadow-lg  py-16 px-5 h-full w-full' onSubmit={(e) => handleSubmit(e)}>
                    <div className='grid w-full grid-cols-2 gap-x-16 gap-y-4'>
                        <ClinicField label='Clinic name:' type='text' name='name' />
                        <ClinicField label='Email Address:' type='email' name='email' />
                        <ClinicField label='Specialities:' type='text' name='specialities' />
                        <ClinicField label='City:' type='text' name='city' />
                        <div className='flex flex-col gap-1'>
                            <label htmlFor="clinicName" className='text-blue-900 font-semibold'>Phone Number:</label>
                            <PhoneInput
                                defaultCountry="in"
                                value={phone}
                                onChange={(phone) => setPhone(phone)}
                            />
                        </div>
                        <ClinicField label='State:' type='text' name='state' />
                        <ClinicField label='Clinic GSTIN No:' type='text' name='regd' />
                        <ClinicField label='PIN Code:' type='number' name='pin' />
                    </div>
                    <button type='submit' className='bg-green-500 text-white rounded-lg px-4 py-2 mt-16 hover:bg-green-700'>Add Clinic</button>
                </form>
                <p className='text-red-500 font-bold italic'>A clinic once added by you will be verified and onboarded. </p>
            </div>
            <div className='w-[28%] my-10 h-full'>
                <ClinicDashBoard2 />
            </div>
        </div>
    )
}

export const ClinicField = ({ label, type, name }) => {
    return (
        <div className='flex flex-col gap-1'>
            <label htmlFor="clinicName" className='text-blue-900 font-semibold'>{label}</label>
            <input type={type} name={name} id='clinicName' className='border-2 border-blue-500 rounded-lg p-1' />
        </div>
    )
}

